"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCreateClientFill = parseCreateClientFill;
exports.isEqual = isEqual;
var cerealParse_1 = require("../cerealParse");
function parseCreateClientFill(o) {
    try {
        var type = cerealParse_1.ParseUtils.getString(o, 'type');
        if (type == 'signupContact') {
            return cerealParse_1.ParseUtils.parseSuccess({
                type: 'signupContact',
                name: cerealParse_1.ParseUtils.getString(o, 'name'),
                email: cerealParse_1.ParseUtils.getString(o, 'email'),
                phone: cerealParse_1.ParseUtils.getStringOrNull(o, 'phone'),
            });
        }
        else {
            return cerealParse_1.ParseUtils.parseFailure("Invalid CreateClientFill: Invalid type '".concat(type, "'"));
        }
    }
    catch (e) {
        return cerealParse_1.ParseUtils.parseFailure("Invalid CreateClientFill: ".concat(e.message));
    }
}
function isEqual(c1, c2) {
    if (c1 == null && c2 == null) {
        return true;
    }
    else if (c1 == null || c2 == null) {
        return false;
    }
    else if (c1.type == 'signupContact' && c2.type == 'signupContact') {
        return c1.name == c2.name && c1.email == c2.email && c1.phone == c2.phone;
    }
    else {
        return false;
    }
}
//# sourceMappingURL=createClientFill.js.map